module.exports = __webpack_public_path__ + "img/gouicon.9a1cec4c.svg";